import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ProjectRead } from '../../entities/project.dto';

@Injectable()
export class ProjectStore extends AbstractEntityStore<ProjectRead> {
    constructor() {
        super(PFWmsEntities.Project);
    }
}
